/* eslint-disable id-blacklist */
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LocationService } from './../../../services/location.service';
import { Mediaclip } from './../../../interfaces/mediaclip';
import { QueryParameter } from './../../../interfaces/queryString';
import { DatafeedFieldconfiguration } from './../../../interfaces/datafeed';

import { Publication } from './../../../interfaces/publication';
import { Datafeed } from '../../../interfaces/datafeed';

import { Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';

import { bbDeepCopy } from '../../../shared/utils/bbDeepCopy.util';
import { BbSelectOption } from '../bb-select/bb-select.component';
import { ToCodePipe } from '../../../pipes/toCode.pipe';
import { DatafeedService } from '../../../services/datafeed.service';
import { MediaclipService } from '../../../services/mediaclip.service';
import { SapiService } from './../../../services/sapi.service';
import { jobActionToStatusMap } from './../../../services/datafeed.service';
import { PublicationService } from './../../../services/publication.service';
import { UUIDV4 } from '../../../shared/tools/UUIDV4';

import * as XLSX from 'xlsx';
import { DialogDefinition, OverlayService } from 'app/services/overlay.service';

@Component({
	selector: 'bb-data-grid',
	templateUrl: './bb-data-grid.component.html',
	styleUrls: ['./bb-data-grid.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbDataGridComponent),
		multi: true
	}]
})

export class BbDataGridComponent implements ControlValueAccessor, OnInit, OnDestroy {
	@Input() form: NgForm;
	datafeed: Datafeed;
	clipEditMode = false;
	addMediaclipProperty: string;
	datafeedId: string;
	_datafeedRows: any[];
	set datafeedRows(rows) {
		this._datafeedRows = rows;
	};
	get datafeedRows(): any[] {
		return this.singleRowData ? [this.singleRowData] : this._datafeedRows;
	}
	xmlDoc: Document;
	parseErrorHtml: SafeHtml;
	itemNode: Element;
	openedNodes: any = {};
	xmlNodeOptions: any[] = [];
	xmlAllNodeOptions: any[] = [];
	xmlItemNodeOptions: any[] = [];
	showRssErrors = false;
	xmlproxyFetchError = false;
	dynamicVideoFilterSet = [{
		filters: [{
			type: 'mediaclip',
			field: 'isDynamic',
			operator: 'is',
			value: 'true'
		}]
	}];
	conditionOptions: any[] = [{
		label: 'Playout used',
		value: 'playout'
	},
	{
		label: 'Local storage',
		value: 'localStorage'
	},
	{
		label: 'Weather',
		value: 'weather'
	}];

	fieldConfigs = {
		string: {
			type: 'string',
			itype: 'string'
		},
		text: {
			type: 'text',
			itype: 'text'
		},
		number: {
			type: 'number',
			itype: 'number'
		},
		video: {
			type: 'relation',
			itype: 'relation',
			contenttype: 'mediaclip',
			contentsubtypes: ['video'],
			contentusetypes: ['editorial', 'commercial']
		},
		image: {
			type: 'relation',
			itype: 'relation',
			contenttype: 'mediaclip',
			contentsubtypes: ['image'],
			contentusetypes: ['editorial', 'commercial']
		},
		mediaclip: {
			type: 'relation',
			itype: 'relation',
			contenttype: 'mediaclip',
			contentusetypes: ['editorial', 'commercial']
		},
		playout: {
			type: 'relation',
			itype: 'relation',
			contenttype: 'playout',
			valueProp: 'label',
			labelProp: 'name'
		},
		boolean: {
			type: 'boolean',
			itype: 'checkbox',
			label: 'Checkbox'
		},
		date: {
			type: 'date',
			itype: 'date'
		}
	};

	fieldTypeOptions: any[] = Object.keys(this.fieldConfigs).map((fieldConfigName) => ({
		label: fieldConfigName,
		value: fieldConfigName,
		data: this.fieldConfigs[fieldConfigName]
	}));
	operatorOptions: any = {
		all: [
			{
				label: 'is',
				value: 'is'
			},
			{
				label: 'is not',
				value: 'isNot'
			},
			{
				label: 'contains',
				value: 'contains',
				types: ['string', 'text']
			},
			{
				label: 'does not contain',
				value: 'doesNotContain',
				types: ['string', 'text']
			},
			{
				label: '>',
				value: '>',
				types: ['number']
			},
			{
				label: '<',
				value: '<',
				types: ['number']
			},
			{
				label: 'Is set',
				value: 'defined'
			},
			{
				label: 'Is not set',
				value: 'undefined'
			}
		]
	};
	mediaclipOptions: any[];
	relatedMediaclips: Mediaclip[];

	newRows: any = {};
	dirtyRows: any = {};

	addConditionOption = '';
	addValueOption = '';
	defaultOperator = 'is';

	workbook: XLSX.WorkBook;
	selectedFile: File;
	fieldConfiguration: DatafeedFieldconfiguration = {};
	sheetOptions: BbSelectOption[];
	selectedSheet: string;
	columnsByType: any = {};
	aeProject: any = {};
	rowEditIndex: any = null;
	rowStoreIdSearch: string;
	singleRowData: any;

	amountRows = 15;
	externalRowCount = null;

	// bbrender
	renderJobs: any = {};

	subscriptions = new Subscription();
	baseurl = '';

	constructor(
		private translate: TranslateService,
		private toCodePipe: ToCodePipe,
		private datafeedService: DatafeedService,
		private publicationService: PublicationService,
		private http: HttpClient,
		private mediaclipService: MediaclipService,
		private locationService: LocationService,
		private sapiService: SapiService,
		private overlayService: OverlayService,
		private sanitizer: DomSanitizer
	) { }

	ngOnInit() {
		['number', 'string', 'text', 'relation'].forEach((type) => {
			this.operatorOptions[type] = this.operatorOptions.all.filter((option: any) => !option.types || option.types.indexOf(type) !== -1);
		});

		this.subscriptions.add(this.publicationService.getData().subscribe((pub: Publication) => {
			if (pub) {
				this.baseurl = this.publicationService.baseUrl;
			}
		}));

		this.mediaclipOptions = this.mediaclipService.getPropertyOptions().filter(property => !property.readOnly);
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	onKeyChange(newKey, index) {
		if (this.datafeed.storageMode) {
			// we won't update rows when using the rowStore
			return;
		}
		const oldKey = this.fieldConfiguration.fieldsCopy[index] && this.fieldConfiguration.fieldsCopy[index].key;
		if (oldKey) {
			if (!this.fieldConfiguration.rows) {
				this.fieldConfiguration.rows = bbDeepCopy(this.datafeedRows);
			}
			this.fieldConfiguration.rows = this.fieldConfiguration.rows.map((row) => {
				const newRow = { ...row };
				if (row[oldKey]) {
					newRow[newKey] = row[oldKey];
					delete newRow[oldKey];
				}
				return newRow;
			});
			this.fieldConfiguration.includeRows = true;
		}
	}

	onSheetSelected(selectedSheet: string) {
		if (selectedSheet && this.workbook) {
			this.workbook.SheetNames.forEach((sheetName: string) => {
				const sheet = this.workbook.Sheets[sheetName];
				if (sheetName === selectedSheet) {
					const headers = [];
					for (const key in sheet) {
						if (sheet[key]) {
							const regEx = new RegExp('^\(\\w\)\(1\){1}$');
							if (regEx.test(key) === true) {
								headers.push(sheet[key].v);
							}
						}
					}
					const sheetJson = XLSX.utils.sheet_to_json(sheet);
					this.handleExcelData(sheetJson, headers);
				}
			});
		}
		this.columnsByType = {
			value: this.datafeed.columns.filter((col: any) => col.headerType === 'value'),
			condition: this.datafeed.columns.filter((col: any) => col.headerType === 'condition')
		};
	}

	onConfigureClick() {
		this.fieldConfiguration = {
			fields: bbDeepCopy(this.datafeed.columns),
			fieldsCopy: bbDeepCopy(this.datafeed.columns)
		};
	}

	onStorageModeChange(storageMode: string) {
		if (storageMode) {
			this.datafeedRows = [];
			if (this.datafeed?.rows) {
				this.datafeed.rows = [];
			}
		}
		this.datafeedChanged(this.datafeed);
	}

	onSingleRowIdChange(rowStoreIdSearch: string) {
		const trimmedRowStoreIdSearch = rowStoreIdSearch?.trim();
		if (trimmedRowStoreIdSearch) {
			this.datafeedService.getRowById(this.datafeed?.id, trimmedRowStoreIdSearch).subscribe((rowData) => {
				this.singleRowData = rowData;
			});
		} else {
			this.singleRowData = null;
			this.getRows();
		}
	}

	rowTrackBy(index: number, item: any) {
		return item?.id || index;
	}

	onUseConditionsChange(useConditions: boolean) {
		if (useConditions) {

		}
	}

	onMediaclipPropertyMappingSelected(propertyOption: any) {
		this.fieldConfiguration.fields.push({
			dataType: propertyOption.type || 'string',
			headerType: 'value',
			xmlPath: '',
			key: propertyOption.value
		});
	}

	handleExcelData(data: any, headers: string[]) {
		if (data && data.length) {
			this.fieldConfiguration = {
				fields: [],
				rows: [],
				isImport: true,
				includeRows: true
			};
			if (!headers || !headers.length) {
				headers = Object.keys(data[0]);
			}
			headers.forEach((key) => {
				const codedKey = this.toCodePipe.transform(String(key));
				// let type = 'textfield';
				// if (data[0] && data[0][key]) {
				// 	type = typeof data[0][key];
				// }
				const column: any = {
					label: key,
					key: codedKey,
					targetKey: codedKey,
					include: true,
					headerType: 'value',
					dataType: 'string'
				};
				this.fieldConfiguration.fields.push(column);
			});
			this.fieldConfiguration.rows = data;
		}
	}

	importData(fieldConfiguration: DatafeedFieldconfiguration, target: any) {
		if (fieldConfiguration && target) {
			const mapping: any = {};
			if (fieldConfiguration.fields && fieldConfiguration.fields.length && target.columns) {
				if (fieldConfiguration.isImport) {
					const conditions: any[] = [];
					fieldConfiguration.fields.forEach((field) => {
						const tc = target.columns.find((col: any) => col.key === field.targetKey);
						if (!tc && field.include) {
							if (field.headerType === 'condition') {
								conditions.push(field);
							} else {
								target.columns.splice(target.columns.length - 1, 0, field);
							}
						}
						if (field.targetKey && field.key !== field.targetKey) {
							mapping[field.key] = field.targetKey;
						}
					});
					if (conditions.length) {
						const insertIndex = target.columns.findIndex((col: any) => col.headerType === 'value') || 0;
						target.columns = target.columns
							.splice(0, insertIndex)
							.concat(conditions)
							.concat(target.columns.splice(insertIndex, target.columns.length));
					}
				} else {
					target.columns = fieldConfiguration.fields;
				}
			}

			if (fieldConfiguration.includeRows && target.rows) {
				if (fieldConfiguration.isImport) {
					// check if there are dates, if yes, convert
					fieldConfiguration.rows = fieldConfiguration.rows.map((row: any) => {
						const dateColumns = fieldConfiguration.fields.filter((column: any) => column.dataType === 'date').map((column: any) => column.key);
						Object.keys(row).forEach((rowKey) => {
							if (dateColumns.includes(rowKey.toLowerCase())) {
								row[rowKey] = this.excelDateToJSDate(row[rowKey]);
							}
						});
						return row;
					});
					let newRows = fieldConfiguration.rows.map((row) => {
						Object.keys(row).forEach((rowKey) => {
							const codedKey = this.toCodePipe.transform(String(rowKey));
							if (rowKey !== codedKey) {
								row[codedKey] = row[rowKey];
								delete row[rowKey];
							}
							if (mapping[codedKey]) {
								row[mapping[codedKey]] = row[codedKey];
								delete row[codedKey];
							}
						});
						return row;
					});
					if (this.datafeed?.storageMode) {
						newRows = newRows.map((row) => {
							row.id = row.id || UUIDV4.getUniqueId();
							return row;
						});
						this.datafeedService.addRows(this.datafeed?.id, newRows).subscribe(() => {
							this.datafeedRows = this.datafeedRows.concat(newRows);
						});
					} else {
						target.rows = target.rows.concat(newRows);
					}
				} else {
					// just update rows with new rowData
					target.rows = fieldConfiguration.rows;
				}

			}
			this.clearConfiguration();
			this.datafeedChanged(this.datafeed);
		}
	}

	excelDateToJSDate(date: number) {
		const jsDate = new Date(Math.round((date - 25569) * 86400 * 1000));
		return jsDate;
	}

	clearConfiguration() {
		this.selectedFile = null;
		this.fieldConfiguration = {};
		this.sheetOptions = [];
	}

	fileChange(ev: any) {
		if (ev.target && ev.target.files && ev.target.files[0]) {
			this.parseExcel(ev.target.files[0]);
		}
	}

	exampleXMLFileChange(ev: any) {
		if (ev.target && ev.target.files && ev.target.files[0]) {
			this.parseExampleXMLFile(ev.target.files[0]);
		}
	}

	parseExampleXMLFile(file: File) {
		const reader = new FileReader();

		reader.onload = (e: any) => {
			const data = e.target.result;
			if (data) {
				this.datafeed.exampleXML = data;
				this.exampleXMLChanged(data);
			}
		};

		reader.onerror = (ex) => {
			console.warn('Error parsing example XML:', ex);
		};

		reader.readAsBinaryString(file);
	}

	exampleXMLChanged(xml) {
		this.parseXml(xml);
		this.datafeedChanged(this.datafeed);
	}

	xslFileChanged(ev: any) {
		if (ev.target && ev.target.files && ev.target.files[0]) {
			this.parseXSLFile(ev.target.files[0]);
		}
	}

	parseXSLFile(file: File) {
		const reader = new FileReader();

		reader.onload = (e: any) => {
			const data = e.target.result;
			if (data) {
				this.datafeed.xsl = data;
				this.datafeedChanged(this.datafeed);
			}
		};

		reader.onerror = (ex) => {
			console.warn('Error parsing example XML:', ex);
		};

		reader.readAsBinaryString(file);
	}

	onRssUrlChange(rssUrl) {
		this.parseRssUrl(rssUrl);
		this.datafeedChanged(this.datafeed);
	}

	parseRssUrl(rssUrl: string) {
		if (!rssUrl) {
			return;
		}
		const encodedURL = encodeURIComponent(rssUrl);

		this.http.get(`${this.locationService.server}/sapi/xmlproxy?u=${encodedURL}`, { responseType: 'text', withCredentials: true }).pipe(catchError((err) => {
			this.xmlproxyFetchError = true;
			return of(null);
		}))
			.subscribe((xml) => {
				this.xmlproxyFetchError = !xml;
				this.parseXml(xml);
			});
	}

	onXmlItemNodePathChange(itemNodePath) {
		if (!this.fieldConfiguration.fields) {
			this.initializeXmlImport();
		}

		this.parseXmlItemNodePath(itemNodePath);
		this.datafeedChanged(this.datafeed);
	}

	onRssItemNodePathChange(rssItemNodePath) {
		if (!this.fieldConfiguration.fields) {
			this.initializeXmlImport();
		}

		this.parseRssItemNodePath(rssItemNodePath);

		// check if MRSS and if so initialize MRSS defaults if there is no mapping yet
		if (rssItemNodePath === '/rss/channel/item') {
			this.initializeMrssDefaults();
		}

		this.datafeedChanged(this.datafeed);
	}

	parseXmlItemNodePath(xmlItemNodePath) {
		this.itemNode = null;
		if (xmlItemNodePath && typeof xmlItemNodePath === 'string') {
			const parts = xmlItemNodePath.split('/');
			const rootEl = parts[1] && this.xmlDoc && this.xmlDoc.querySelectorAll(parts.map(item => encodeURIComponent(item).replace('%', '\\')).join(' '));
			this.itemNode = rootEl && rootEl[0];
		}

		if (!this.itemNode && this.xmlDoc) {
			this.itemNode = this.xmlDoc.firstElementChild;
		}

		this.xmlItemNodeOptions = [];
		if (this.itemNode) {
			this.addXMLNodesAsOptions(this.itemNode, this.xmlItemNodeOptions, false, this.datafeed.rssItemNodePath);
		}
	}

	parseRssItemNodePath(rssItemNodePath) {
		if (rssItemNodePath && typeof rssItemNodePath === 'string') {
			const xmlNode = this.xmlDoc
				&& this.xmlDoc.querySelectorAll(rssItemNodePath.split('/').map(item => encodeURIComponent(item).replace('%', '\\')).join(' '));
			this.itemNode = xmlNode && xmlNode[0];
			if (this.itemNode) {
				this.xmlItemNodeOptions = [];
				this.addXMLNodesAsOptions(this.itemNode, this.xmlItemNodeOptions, false, this.datafeed.rssItemNodePath);
			}
		}
	}

	initializeXmlImport() {
		this.fieldConfiguration = {
			fields: this.datafeed.fieldMapping || [],
			isMapping: true
		};

		this.datafeed.fieldMapping = this.fieldConfiguration.fields; // object bound

		this.searchRelatedClips();
	}

	searchRelatedClips() {
		const queryParams: QueryParameter[] = [];
		const query = `relationLabel_multistring:"Datafeed${this.datafeed.id}"`;
		queryParams.push({ name: 'q', values: [query] } as QueryParameter);
		this.sapiService.query('commonclip', queryParams).subscribe(response => {
			if (response && response.items && response.items.length > 0) {
				this.relatedMediaclips = response.items;
			}
		});
	}

	xpath(path, doc, startNodePath?) {
		if (!doc || !doc.evaluate || !path) {
			return false;
		}
		if (startNodePath && path.startsWith('./')) {
			path = path.replace('.', startNodePath);
		}
		const evaluator = new XPathEvaluator();
		const resolver = evaluator.createNSResolver(doc.documentElement);
		const xpathResult = doc.evaluate(path, doc, resolver);
		const el = xpathResult.iterateNext();
		return el;
	}

	initializeMrssDefaults() {
		if (!this.fieldConfiguration.fields) {
			this.initializeXmlImport();
		}
		const mrssDefaults = {
			rssItemPath: '/rss/channel/item',
			rssUpdateCheckPath: '/rss/channel/pubDate',
			rssItemIDPath: './guid',
			rssItemVideoPath: './media:content/@url',
			rssItemThumbnailPath: './media:content/media:thumbnail/@url',
			rssItemThumbnailWidthPath: './media:content/media:thumbnail/@width',
			rssItemThumbnailHeightPath: './media:content/media:thumbnail/@height'
		};

		for (const prop in mrssDefaults) {
			if (Object.prototype.hasOwnProperty.call(mrssDefaults, prop)) {
				const path = mrssDefaults[prop];
				if (typeof this.datafeed[prop] === 'undefined' && this.xpath(path, this.xmlDoc, mrssDefaults.rssItemPath)) {
					this.datafeed[prop] = path;
				}
			}
		}

		const mediaclipDefaultMRSSPaths = [{
			key: 'title',
			dataType: 'string',
			headerType: 'value',
			xmlPath: './title'
		},
		{
			key: 'description',
			dataType: 'string',
			headerType: 'value',
			xmlPath: './description'
		},
		{
			key: 'length',
			dataType: 'int',
			headerType: 'value',
			xmlPath: './media:content/@duration'
		},
		{
			key: 'cat',
			dataType: 'multistring',
			headerType: 'value',
			xmlPath: './media:content/media:tags'
		},
		{
			key: 'sourceid',
			dataType: 'string',
			headerType: 'value',
			xmlPath: './guid'
		}];

		mediaclipDefaultMRSSPaths.forEach((def) => {
			if (!this.fieldConfiguration.fields.find(field => def.key === field.key)) {
				if (this.xpath(def.xmlPath, this.xmlDoc, mrssDefaults.rssItemPath)) {
					this.fieldConfiguration.fields.push(def);
				}
			}
		});

		this.datafeedChanged(this.datafeed);
	}

	parseXml(xml: string) {
		const parser = new DOMParser();
		(window as any).rssdoc = this.xmlDoc = parser.parseFromString(xml, 'text/xml');

		this.xmlAllNodeOptions = [{
			label: 'Root node',
			value: '/'
		}];
		this.addXMLNodesAsOptions(this.xmlDoc, this.xmlAllNodeOptions);
		this.xmlNodeOptions = [{
			label: 'Root node',
			value: '/'
		}];
		this.addXMLNodesAsOptions(this.xmlDoc, this.xmlNodeOptions, true);

		if (this.isMRSS(this.xmlDoc) && !this.datafeed.rssItemNodePath) {
			this.datafeed.rssItemNodePath = '/rss/channel/item';
			this.initializeMrssDefaults();
		}

		if (this.datafeed && this.datafeed.rssItemNodePath) {
			this.parseRssItemNodePath(this.datafeed.rssItemNodePath);
		}

		if (this.datafeed && this.datafeed.xmlItemNodePath) {
			this.parseXmlItemNodePath(this.datafeed.xmlItemNodePath);
		}

		// console.warn('this.mrssXmlDoc', this.rssXmlDoc, this.xmlNodeOptions);
	}

	isMRSS(rssXmlDoc: Document): boolean {
		if (rssXmlDoc && rssXmlDoc.querySelectorAll) {
			const rssNode = rssXmlDoc.querySelector('rss');
			const parserErrorEl = rssXmlDoc.querySelector('parsererror');
			if (parserErrorEl) {
				console.warn('There was an error in parsing the RSS feed XML. Rss XML document:', rssXmlDoc);
				this.parseErrorHtml = this.sanitizer.bypassSecurityTrustHtml(parserErrorEl.innerHTML);
				return false;
			} else {
				this.parseErrorHtml = '';
			}
			if (!rssNode) {
				return false;
			}
			const xmlnsAttr = rssNode.getAttribute('xmlns:media');
			if (!xmlnsAttr) {
				return false;
			}
			if (rssNode.querySelector('channel') && xmlnsAttr.includes('mrss')) {
				return true;
			}
		}
		return false;
	}

	addXMLNodesAsOptions(node: any, options, nodesOnly = false, rootPath = null) {
		options = options || [];
		if (options.find(option => option.nodeName === node.nodeName)) {
			return;
		}
		const path = this.getPathTo(node, rootPath);
		if (node.nodeName && !node.nodeName.startsWith('#') && (node.textContent || (node.attributes && node.attributes.length))) {
			if (nodesOnly || !this.isEmptyNode(node)) {
				options.push({
					label: path + (nodesOnly ? '' : ' #text'),
					value: path,
					aliases: path.split('/'),
					nodeName: node.nodeName
				});
			}
		}

		if (!nodesOnly && node.attributes && node.attributes.length) {
			for (let i = 0; i < node.attributes.length; i++) {
				const attr = node.attributes[i];
				const attrPath = path + '/@' + attr.nodeName;
				options.push({
					label: attrPath,
					aliases: path.split('/'),
					value: attrPath,
					nodeName: node.nodeName
				});

			}
		}
		if (node && node.childNodes && node.childNodes.length) {
			node.childNodes.forEach(element => {
				this.addXMLNodesAsOptions(element, options, nodesOnly, rootPath);
			});
		}
	}

	isEmptyNode(node) {
		return !node || !node.textContent || node.textContent.trim() === '';
	}

	getPathTo(element, fromNodePath?) {
		if (!element.parentNode) {
			return '';
		}
		if (element === document.body) {
			return element.tagName;
		}

		// let ix = 0;
		const siblings = element.parentNode.childNodes;
		for (let i = 0; i < siblings.length; i++) {
			const sibling = siblings[i];
			if (sibling === element) {
				return (this.getPathTo(element.parentNode, fromNodePath) + '/' + element.tagName).replace(fromNodePath, '.'); // + '[' + (ix + 1) + ']'
			}

			// if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
			// 	ix++;
			// }
		}
	}

	parseExcel(file: File) {
		const reader = new FileReader();

		reader.onload = (e: any) => {
			const data = e.target.result;
			this.workbook = XLSX.read(data, {
				type: 'binary'
			});

			if (this.workbook.SheetNames.length) {
				this.sheetOptions = this.workbook.SheetNames.map((sheetName) => ({
					label: sheetName,
					value: sheetName
				}));
			}
			this.selectedSheet = this.sheetOptions[0].value;
			this.onSheetSelected(this.selectedSheet);
		};

		reader.onerror = (ex) => {
			console.warn('Error parsing excel:', ex);
		};

		reader.readAsBinaryString(file);
	}

	aeFileChange(ev: any) {
		if (ev.target && ev.target.files && ev.target.files[0]) {
			const file = ev.target.files[0];
			const reader = new FileReader();

			reader.onload = (e: any) => {
				this.datafeedChanged(this.datafeed);
				this.parseAe(e.target.result);
			};

			reader.onerror = (ex) => {
				console.warn('Error parsing After Effects XML:', ex);
			};

			reader.readAsBinaryString(file);
		}
	}

	/* AfterEffects XML parsing is still WIP */
	parseAe(aeXml: any) {
		const parser = new DOMParser();
		const xmlDoc = parser.parseFromString(String(aeXml), 'text/xml');
		// console.warn('xmlDoc', xmlDoc);

		this.aeProject.compositions = [];
		this.aeProject.compositionOptions = [];
		this.aeProject.layerOptions = { '*': [] };
		this.aeProject.propertyOptions = [];
		const compositions = Array.prototype.slice.call(xmlDoc.querySelectorAll('Item'));
		compositions.forEach((comp: any) => {
			// Filters out compositions only
			if (!comp.querySelector('idta[bdata]') || !comp.querySelector('idta').getAttribute('bdata').startsWith('0004')) {
				return;
			}

			const c = {
				name: comp.querySelector('string').textContent,
				element: comp,
				layers: Array.prototype.slice.call(comp.querySelectorAll('Layr')).map((layr: any) => ({
					name: layr.querySelectorAll('string')[0].textContent,
					element: layr
				}))
			};

			if (c.name) {
				const namedLayers = Array.prototype.slice.call(comp.querySelectorAll('Layr')).map((layr: any) => ({
					label: layr.querySelectorAll('string')[0].textContent,
					value: layr.querySelectorAll('string')[0].textContent
				})).filter((layerOption: any) => layerOption.value);
				this.aeProject.layerOptions['*'] = this.aeProject.layerOptions['*'].concat([...namedLayers]);

				this.aeProject.compositions.push(c);
				this.aeProject.compositionOptions.push({
					label: c.name,
					value: c.name
				});
				if (namedLayers.length) {
					this.aeProject.layerOptions[c.name] = namedLayers;
				}
			}
		});
		this.aeProject.compositionOptions.sort((a: any, b: any) => a.label.localeCompare(b.label));
		this.aeProject.compositionOptions.unshift({
			label: this.translate.instant('ALL_COMPOSITIONS'),
			value: '*'
		});
		this.datafeed.aeProject = this.aeProject;
	}

	log(content: any) {
		console.warn('log', content);
	}

	onOperatorSelected(row: any, modelKey: string, operatorOption: any) {
		let model = row[modelKey];
		if (typeof model !== 'object' || model === null) {
			model = {
				value: typeof model === 'undefined' || model === null ? '' : model
			};
		}
		model.operator = operatorOption.value;
		row[modelKey] = model;
		this.datafeedChanged(this.datafeed, row);
	}

	isObj(item: any) {
		return item && typeof item === 'object';
	}

	addRow(row: any = {}, duplicating = false) {
		if (this.datafeedRows) {
			this.newRows[this.datafeedRows.length - 1] = false;
			this.newRows[this.datafeedRows.length] = true;
			if (this.datafeed.feedType === 'renderedVideo' || this.datafeed?.storageMode) {
				row.id = UUIDV4.getUniqueId();
				if (!duplicating) {
					row.composition = void (0);
				}
			}
			if (this.datafeed.storageMode) {
				this.singleRowData = row;
				this.rowStoreIdSearch = row.id;
				this.datafeedService.addRows(this.datafeed.id, [row]).subscribe((res) => {
					this.singleRowData = row;
					this.datafeed.rowCount++;
					this.datafeedService.externalRowCount++;
					this.editRow(this.datafeedRows.length - 1);
					this.overlayService.createToast('Successfully added a new row', 'success');
				});
			} else {
				this.datafeedRows.push(row);
				this.datafeed.rows = this.datafeedRows;
				this.datafeedChanged(this.datafeed);
				this.editRow(this.datafeedRows.length - 1);
			}
		}
	}

	getRows() {
		this.datafeedService.getRows(this.datafeed.id).subscribe((res) => {
			this.datafeedRows = res?.rows || [];
			this.amountRows = Math.max(this.amountRows, this.datafeedRows.length);
		});
	}

	loadMoreRows() {
		this.rowStoreIdSearch = null;
		this.singleRowData = null;
		this.datafeedService.getRows(this.datafeedId, true).subscribe((data) => {
			if (data?.rows?.length) {
				this.datafeedRows = this.datafeedRows.concat(data.rows);
				this.amountRows = Math.max(this.amountRows, this.datafeedRows.length);
			}
		});
	}

	updateRow(row: any, index: number) {
		if (this.datafeed.storageMode === 's3') {
			this.datafeedService.updateRow(this.datafeed.id, row).subscribe((res) => {
				delete this.dirtyRows[row?.id];
				this.overlayService.createToast(`Successfully updated row with ID ${row?.id}`, 'success');
			});
		}
	}

	deleteRow(row: any, index: number) {
		if (this.datafeed.storageMode) {
			this.datafeedService.deleteRows(this.datafeed.id, [row?.id]).subscribe((res) => {
				this.singleRowData = null;
				this.rowStoreIdSearch = null;
				this.datafeed.rowCount--;
				this.datafeedRows.splice(index, 1);
				this.overlayService.createToast(`Successfully deleted row with ID ${row?.id}`, 'success');
			});
		} else {
			this.datafeed.rows.splice(index, 1);
			this.datafeed.rows = this.datafeedRows;
			this.datafeedChanged(this.datafeed);
		}
	}

	deleteAllRows() {
		const storageMode =  this.datafeed?.storageMode;
		// define the dialog
		const config = {
			nr: storageMode ? this.datafeed.rowCount || this.datafeedRows.length: this.datafeedRows.length,
			entities: this.translate.instant('ROWS').toLowerCase()
		};
		let contents = this.translate.instant('DELETE_NUMBER_ENTITIES_CONFIRM', config);
		if (config.nr === 1) {
			contents = this.translate.instant('DELETE_SINGLE_ENTITY_CONFIRM', { entity: this.translate.instant('ROW').toLowerCase() });
		}
		if (storageMode) {
			contents += ' ' + this.translate.instant('THIS_CANNOT_BE_UNDONE');
		}
		const dialog: DialogDefinition = {
			icon: 'trash-o',
			title: this.translate.instant('CLEAR_ALL_ROWS_CONFIRM'),
			contents,
			onConfirm: () => {
				if (storageMode) {
					this.datafeedService.deleteAllRows(this.datafeed?.id, true).subscribe(() => {
						const msg = this.translate.instant('X_ROWS_HAVE_SUCCESFULLY_BEEN_DELETED', { x: config.nr });
						this.overlayService.createToast(msg, 'info-circle');
					});
				} else {
					const msg = this.translate.instant('X_ROWS_HAVE_SUCCESFULLY_BEEN_DELETED', { x: config.nr });
					this.overlayService.createToast(msg, 'info-circle');
					this.datafeed.rows = [];
					this.datafeedRows = [];
					this.overlayService.setLoading(false);
					this.datafeedChanged(this.datafeed);
				}
			}
		};
		this.overlayService.createDialog(dialog);
	}

	duplicateRow(row: any, index: number) {
		const newRow = bbDeepCopy(row);
		if (this.datafeed?.storageMode) {
			this.addRow(newRow, true);
		} else {
			if (newRow.id) {
				newRow.id = UUIDV4.getUniqueId();
			}
			this.datafeed.rows.splice(index, 0, newRow);
			this.datafeedChanged(this.datafeed);
		}
	}

	editRow(index: number) {
		this.rowEditIndex = index;
	}

	closeEditRow() {
		this.rowEditIndex = null;
	}

	updateRenderJob(action, row) {
		if (!row || !jobActionToStatusMap[action]) {
			return;
		}

		this.datafeedService.updateRenderJob(this.datafeed.id, row, action).subscribe((data) => {
			if (data && data.id) {
				this.renderJobs[data.id] = data;
			} else {
				this.renderJobs[row.id] = { status: jobActionToStatusMap[action] };
			}
		});
	}

	startRender(row: any) {
		if (row) {
			this.datafeedService.startRenderJob(this.datafeed.id, row).subscribe((data) => {
				if (data && data.id) {
					this.renderJobs[data.id] = data;
				} else {
					this.renderJobs[row.id] = { status: 'queued' };
				}
			});
		} else {
			this.datafeedService.startRenderJob(this.datafeed.id).subscribe((data) => {
				if (data && data.jobs && data.jobs.length) {
					data.jobs.forEach((job) => {
						this.renderJobs[job.id] = job;
					});
				} else {
					this.getRenderStatus();
				}
			});
		}
	}

	getRenderStatus() {
		this.datafeedService.getRenderStatus(this.datafeed.id).subscribe((response) => {
			// console.warn('datafeedService.getRenderStatus data', response);
			if (response?.data?.jobs?.length) {
				response.data.jobs.forEach((job) => {
					if (job && job.id) {
						this.renderJobs[job.id] = job;
					}
				});
			}
		});
	}

	removeColumn(index: number) {
		this.datafeed.columns.splice(index, 1);
		this.datafeedChanged(this.datafeed);
	}

	removeFieldmapping(index: number) {
		this.datafeed.fieldMapping.splice(index, 1);
		this.datafeedChanged(this.datafeed);
	}

	addColumn(headerType: string, dataType: string, columnIndex: number) {
		let newKeyIndex = 1;
		let newKey = dataType + newKeyIndex;
		while (this.datafeed.columns.find((col: any) => col.key === newKey)) {
			newKeyIndex++;
			newKey = dataType + newKeyIndex;
		}
		const column: any = {
			headerType,
			dataType,
			key: newKey,
			label: newKey
		};
		this.datafeed.columns.splice(columnIndex, 0, column);
		this.datafeedChanged(this.datafeed);

		setTimeout(() => {
			this.addConditionOption = '';
			this.addValueOption = '';
		});
	}

	initializeRenderedVideoType() {
		const idColumn = this.datafeed.columns.find((col) => col.key === 'id');
		const compositionColumn = this.datafeed.columns.find((col) => col.key === 'composition');

		if (!compositionColumn) {
			// add composition column
			// checks index for the few datafeeds that already had an id column to have composition be second
			this.datafeed.columns.splice(this.datafeed.columns.indexOf(idColumn) > -1 ? 1 : 0, 0, {
				dataType: 'string',
				headerType: 'composition',
				label: 'composition',
				key: 'composition'
			});
		}

		if (!idColumn) {
			// add ID column
			this.datafeed.columns.splice(0, 0, {
				dataType: 'string',
				headerType: 'id',
				label: 'id',
				key: 'id'
			});
		}
	}

	// ControlValueAccessor fields:
	writeValue(data: Datafeed) {
		this.newRows = {};

		if (this.fieldConfiguration && this.fieldConfiguration.fields) {
			delete this.fieldConfiguration.fields;
		}

		if (data) {
			this.datafeed = data;
		} else {
			this.datafeed = {};
		}
		if (!this.datafeed.rows) {
			this.datafeed.rows = [];
		}
		if (this.datafeed.feedType === 'renderedVideo') {
			this.initializeRenderedVideoType();
		}

		if (!this.datafeed.columns) {
			this.datafeed.columns = [];
		}

		if (this.datafeed.aeProject) {
			this.aeProject = this.datafeed.aeProject;
		}

		if (this.datafeed.rssUrl) {
			this.parseRssUrl(this.datafeed.rssUrl);
		}

		if (this.datafeed.exampleXML) {
			this.parseXml(this.datafeed.exampleXML);
		}

		if (this.datafeed.feedType === 'rssFeedImport' && this.datafeed.rssUrl) {
			this.initializeXmlImport();
		}

		if (this.datafeed.feedType === 'xmlUploadImport' && this.datafeed.xmlItemNodePath) {
			this.initializeXmlImport();
			this.parseXmlItemNodePath(this.datafeed.xmlItemNodePath);
			if (!this.mediaclipOptions.find(opt => opt.value === 'id')) {
				this.mediaclipOptions.push({
					value: 'id',
					label: 'ID'
				});
			}
		}

		if (this.datafeed.id) {
			if (this.datafeedId !== this.datafeed.id && this.datafeed.feedType === 'renderedVideo' && this.datafeed.dynamicMediaclip) {
				this.getRenderStatus();
			}
			this.datafeedId = this.datafeed.id;
		}

		if (this.datafeed?.storageMode) {
			this.datafeedService.externalRowCount = this.datafeed.rowCount;
			this.getRows();
		} else {
			this.datafeedRows = this.datafeed.rows;
		}
	}

	datafeedChanged(datafeed, row?) {
		if (this.datafeed?.storageMode === 's3' && row) {
			this.dirtyRows[row?.id] = true;
			return;
		}
		this.propagateChange(datafeed);
	}

	propagateChange = (_: any) => { };

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
